import { usePostS3UploadUrlArrayCustomCotation } from "@/api/s3.api";
import * as nanoid from "nanoid";
import { PostPutPresignedUrlArrayDto, DocumentUrlDto } from "@/types/api/api-types";
import { useCallback } from "react";

export const useS3Upload = () => {
  const { mutateAsync: postS3UploadUrlArray } = usePostS3UploadUrlArrayCustomCotation();

  // files: File[]
  // options: { isPrivate: boolean, s3Prefix: string, id?: string }
  const uploadFiles = useCallback(
    async (files: File[], options: { isPrivate: boolean; s3Prefix: string }): Promise<string[]> => {
      if (!files || files.length === 0) return [];
      const { isPrivate, s3Prefix } = options;
      const urlsArray: PostPutPresignedUrlArrayDto = {
        urls: files.map((file) => ({
          id: "",
          key: `${s3Prefix}/${nanoid.nanoid()}_${file.name}`,
          isInvoice: false,
          contentType: file.type,
        })),
        isPrivate,
      };
      try {
        const ret = await postS3UploadUrlArray(urlsArray);
        const signedUrlArray: DocumentUrlDto = ret.data;
        if (!signedUrlArray || signedUrlArray.length === 0) return [];
        const uploadPromises: Promise<any>[] = [];
        for (const signedUrl of signedUrlArray) {
          const fileName = signedUrl.key.split("/")[1]?.slice(22);
          const file = files.find((otherFile) => otherFile.name === fileName);
          if (!file) continue;
          uploadPromises.push(
            fetch(signedUrl.url, {
              method: "PUT",
              body: file,
              headers: {
                "Content-Type": file.type,
              },
            }),
          );
        }
        await Promise.all(uploadPromises);
        return signedUrlArray.map((el) => el.key);
      } catch (error) {
        console.error("Error uploading file:", error);
        return [];
      }
    },
    [postS3UploadUrlArray],
  );

  return { uploadFiles };
};
